const SECONDS_IN_A_MINUTE = 60;
const METERS_IN_A_KILOMETER = 1000;

/**
 * Transform the seconds to minutes for the isochrone related logic
 * The profile specifies the maximum duration value in seconds but the user works in
 * minutes. When transforming from seconds to minutes the value is rounded floor.
 * It means the user cannot setup a small range of values for the second up to the last minute
 * but that is the price to change the unit
 *
 * @param {number} seconds - Seconds to be transformed
 * @return {number} minutes
 */
export function toMinutes (seconds) {
  return Math.floor(seconds / SECONDS_IN_A_MINUTE);
}

export function toSeconds (minutes) {
  return minutes * SECONDS_IN_A_MINUTE;
}

/**
 * Transform the meters provided by the profile to kilometers (the unit used by the user)
 * The km value is always rounded floor because it cannot be bigger than the provided one
 *
 * For example:
 * 1426m -> 1.42km because if it is rounded to 1.43km it will be an invalid value
 * transforming it back to meters
 *
 * @param {number} meters - meters to be transformed
 * @return {number} kilometers
 */
export function toKilometers (meters) {
  const arrayNumber = (meters / METERS_IN_A_KILOMETER).toString().split('.');
  if (arrayNumber.length > 1) {
    arrayNumber[1] = arrayNumber[1].slice(0, 2);
  }
  return parseFloat(arrayNumber.join('.'));
}

export function toMeters (kilometers) {
  return kilometers * METERS_IN_A_KILOMETER;
}
